// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".label[data-v-4dcc0954]{font-weight:700}button.btn.btn-primary.btn-block[data-v-4dcc0954]{background-color:#337ab7;border-color:#337ab7}.help.is-danger[data-v-4dcc0954]{color:red;font-size:12px;font-weight:400}.form-group.text-center[data-v-4dcc0954]{margin-bottom:15px}.dark-panel[data-v-4dcc0954]{background:#c3c3c3;padding:1.25rem;margin-bottom:1.25rem;border-radius:4px}.form-title[data-v-4dcc0954]{font-size:28px}", ""]);
// Exports
module.exports = exports;
